import { Injectable } from "@angular/core";
import { ApiEsService } from "./api-es.service";
import { FileUploadRequestES } from "@edp-models/ES/es-file-upload.model";


@Injectable({
    providedIn: "root",
})
export class FileUploadServiceES {
    constructor(private apiService: ApiEsService) { }

    public uploadFile(data: FileUploadRequestES) {
        return this.apiService.callServicePostToCollection(`resource.add`, data);
    }

    /* public uploadCustomerSupportFile(args) {
        return this.apiService.callServicePost("customerSupport.uploadFile", args);
    }

    public uploadCustomerSupportMultiFiles(args: { files: Array<any> }) {
        return this.apiService.callServicePost("customerSupport.multipleUploadFiles", args);
    } */
}
